<template>
  <ValidationObserver ref="formAdditionalTimeSheet" v-slot="{ handleSubmit }">
    <CForm @submit.prevent="handleSubmit(registerOverTimeRequest)">
      <div class="modal_outer_cover">
        <div class="create_body_part">
          <div class="content_create">
            <div class="create_title">
              <span>{{$t("dashboard.modal.edit_timesheet")}}</span>
              <div class="card-modal-button" @click="$emit('closeModal')">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L13 13M1 13L13 1L1 13Z"
                    stroke="#626262"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div class="create_bottom">
              <div class="replenishment_date">
                <span class="title"
                  >Ngày bổ sung <span class="star">*</span></span
                >
                <DatePickerForm
                  id="error-mobile"
                  :propsDate="
                    forms.work_date ? forms.work_date : forms.current_date
                  "
                  v-on:emitDate="workDateData"
                  :rules="{
                    required_date: true,
                    before_or_equal_today: true,
                  }"
                  :name="'additional_timeSheet.request_date'"
                />
              </div>
              <div class="create_admin">
                <div>
                  <span class="title">Admin <span class="star">*</span></span>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="additional_timeSheet.admin"
                  >
                    <select class="form-control" v-model="forms.admin_id">
                      <option
                        v-for="(option, index) in dataCreateForm.admin"
                        :key="index"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div>
                  <span class="title">Manager <span class="star">*</span></span>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="additional_timeSheet.manager"
                  >
                    <select class="form-control" v-model="forms.manager_id">
                      <option
                        v-for="(option, index) in dataCreateForm.manager"
                        :key="index"
                        :value="option.id"
                      >
                        {{ option.name }}
                      </option>
                    </select>
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="morning_time">
                <div>
                  <span class="title">Thời gian bắt đầu</span>
                  <div class="form-control bg-text" style="width: 100%">
                    {{ forms.start_time_real | formatHour }}
                  </div>
                </div>
                <div>
                  <span class="title"
                    >Sửa thời gian bắt đầu <span class="star">*</span></span
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="additional_timeSheet.check_in_request"
                  >
                    <b-form-input
                      type="text"
                      v-model="forms.start_time_request"
                      v-mask="'##:##'"
                      placeholder="HH:mm"
                    />
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="departure_time">
                <div>
                  <span class="title">Thời gian kết thúc</span>
                  <div class="form-control bg-text" style="width: 100%">
                    {{ forms.end_time_real | formatHour }}
                  </div>
                </div>
                <div>
                  <span class="title"
                    >Sửa thời gian kết thúc <span class="star">*</span></span
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="additional_timeSheet.check_out_request"
                  >
                    <b-form-input
                      type="text"
                      v-model="forms.end_time_request"
                      v-mask="'##:##'"
                      placeholder="HH:mm"
                    />
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <!-- <input type="text" v-model="forms.end_time_request"> -->
                </div>
              </div>
              <CRow class="form_image">
                <CCol md="6" class="form-field">
                  <label class="title"
                    >Bằng chứng ( tối đa 2 ảnh )
                    <span class="require"> *</span></label
                  >
                  <ValidationProvider
                    rules="img|size:2000"
                    v-slot="{ errors }"
                    name="additional_timeSheet.evidence"
                  >
                    <div clas="file_input_wrap" style="display: none">
                      <input
                        type="file"
                        class="form-control-file mb-1"
                        v-on:change="onImageChange"
                        id="fileImage"
                        multiple
                      />
                    </div>
                    <div clas="file_input_wrap">
                      <label for="fileImage" class="file__input">
                        <div class="file-input__label">
                          <img src="../../../assets/icons/file.svg" alt="" />
                          <span class="file-input__choose">{{
                            $t("fields.additional_timeSheet.img_upload")
                          }}</span>
                        </div>
                      </label>
                    </div>
                    <span v-if="!isImage" class="error image required">
                      {{ errorFileMessage }}
                    </span>
                    <span class="required">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div
                    class="img__name mb-1"
                    v-for="(data, index) in image_name"
                    :key="index"
                  >
                    <div class="img-name__text">
                      {{ data }}
                    </div>
                    <div class="img-btn__close" @click="removeImage(index)">
                      <div class="image_delete">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L13 13M1 13L13 1L1 13Z"
                            stroke="#626262"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>

                      <CIcon name="cil-x" width="16" />
                    </div>
                  </div>
                </CCol>
                <CCol md="6">
                  <br />
                  <div v-if="image_evidence.length > 0">
                    <img
                      v-for="(data, index) in image_evidence"
                      :key="index"
                      v-img
                      class="image-evidence"
                      :src="data"
                      width="100"
                      height="100"
                    />
                  </div>
                  <img
                    v-else
                    class="image-evidence"
                    src="@/assets/images/no-image-available.jpg"
                    width="100"
                    height="100"
                  />
                </CCol>
              </CRow>
              <div class="reason">
                <span class="title"
                  >Lý do chỉnh sửa <span class="star">*</span></span
                >
                <ValidationProvider
                  rules="required|max:512"
                  v-slot="{ errors }"
                  name="additional_timeSheet.reason"
                >
                  <b-form-textarea
                    id="textarea"
                    v-model="forms.reason"
                    rows="5"
                    max-rows="6"
                  ></b-form-textarea>
                  <span class="required">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="button_create">
                <CButton type="submit" class="button_confirm">
                  {{ $t("label.save_infomation") }}
                </CButton>
                <CButton
                  class="button_cancel"
                  type="button"
                  @click="cancel()"
                  >{{ $t("commons.cancel") }}</CButton
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </CForm>
  </ValidationObserver>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import moment from "moment";
import DatePickerForm from "@/components/commons/DatePickerForm";

export default {
  metaInfo() {
    return {
      title: this.$t("page_title.page_additional_timeSheet_create"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    DatePickerForm,
  },
  computed: {
    ...mapGetters({
      dataCreateForm: "additional-timesheet/dataCommonAdditionalTimeSheet",
    }),
    workDate() {
      return this.forms.work_date;
    },
  },
  data() {
    return {
      errorFileMessage: "",
      imageType: [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/PNG",
        "image/JPG",
      ],
      isImage: true,
      image_evidence: [],
      image_name: [],
      forms: {
        work_date: null,
        admin_id: "",
        manager: "",
        start_time_real: "",
        end_time_real: "",
        end_time_request: "17:30:00",
        start_time_request: "08:00:00",
        reason: null,
        img_evidence: [],
        current_date: moment(new Date()).format("DD/MM/YYYY"),
      },
    };
  },

  created() {
    this.getDataCreateForm();
    if (this.$route.params.work_date) {
      this.forms.work_date = this.$route.params.work_date;
      this.forms.start_time_request =
        this.$route.params.start_time_real !== ""
          ? this.$route.params.start_time_real
          : this.forms.start_time_request;
      this.forms.end_time_request =
        this.$route.params.end_time_real !== ""
          ? this.$route.params.end_time_real
          : this.forms.end_time_request;
    } else {
      this.forms.work_date = moment(new Date()).format("DD/MM/YYYY");
    }
  },

  watch: {
    workDate() {
      this.getDataCreateForm();
    },
  },

  methods: {
    workDateData(data) {
      this.forms.work_date = data;
    },
    async registerOverTimeRequest() {
      if (!this.forms.img_evidence.length) {
        this.isImage = false;
        this.errorFileMessage =
          this.$t("additional_timeSheet.evidence") +
          " " +
          this.$t("error.require");
        return false;
      }
      this.$root.$loading.start();
      let formData = new FormData();
      for (let key in this.forms) {
        if (key === "img_evidence") {
          if (this.forms.img_evidence && this.forms.img_evidence.length > 0) {
            for (let i = 0; i < this.forms.img_evidence.length; i++) {
              formData.append(`img_evidence[${i}]`, this.forms.img_evidence[i]);
            }
          }
        } else {
          formData.append(key, this.forms[key]);
        }
      }
      await this.$store
        .dispatch("additional-timesheet/registerAdditionalTimeSheet", formData)
        .then(() => {
          let message = this.$t("overtime.message_create_success");
          this.$toast(message, null, 2000, "b-toaster-top-center", "success");
          // this.$router.push({ path: "/additional-timesheet" });
          this.$root.$loading.finish();
          this.$emit("closeModal");
          this.$emit("fetchData");
        })
        .catch(() => {
          this.$root.$loading.finish();
        });
    },

    // change image
    onImageChange(e) {
      if (e.target.files.length + this.forms.img_evidence.length > 2) {
        this.errorFileMessage = "Vui lòng chọn tối đa 2 ảnh";
        this.isImage = false;
        return;
      }
      let file = e.target.files[0];
      let file2 = e.target.files[1];
      if (
        e.target.files[0] &&
        !this.imageType.includes(e.target.files[0].type)
      ) {
        this.isImage = false;
        this.forms.img_evidence = [];
        this.errorFileMessage = this.$t("error.img_type");
        return;
      }
      if (
        e.target.files[1] &&
        !this.imageType.includes(e.target.files[1].type)
      ) {
        this.isImage = false;
        this.forms.img_evidence = [];
        this.errorFileMessage = this.$t("error.img_type");
        return;
      }
      // check size file
      // if (file.size > 2000000 || file2?.size > 2000000) {
      //   this.isImage = false;
      //   this.errorFileMessage = this.$t("error.img_max");
      //   return;
      // }
      //display image is choosen
      if (file !== undefined) {
        let fileName = file.name;
        this.image_evidence.push(URL.createObjectURL(file));
        this.forms.img_evidence.push(file);
        this.image_name.push(fileName);
      }
      if (file2 !== undefined) {
        let fileName2 = file2.name;
        this.image_evidence.push(URL.createObjectURL(file2));
        this.forms.img_evidence.push(file2);
        this.image_name.push(fileName2);
      }
      this.errorFileMessage = null;
      this.isImage = true;
      // this.image_evidence = file !== undefined ? URL.createObjectURL(file) : "";
      // this.errorFileMessage = null;
      // this.isImage = true;
      // this.forms.img_evidence =
      //   e.target.files[0] !== undefined ? e.target.files[0] : "";
    },
    removeImage(index) {
      this.forms.img_evidence.splice(index, 1);
      this.image_evidence.splice(index, 1);
      this.image_name.splice(index, 1);
    },

    async getDataCreateForm() {
      let date = moment(this.forms.work_date, "DD/MM/YYYY", true);
      if (date.isValid()) {
        this.$root.$loading.start();
        await this.$store.dispatch(
          "additional-timesheet/commonAdditionalTimeSheet",
          { work_date: this.forms.work_date }
        );
        this.forms.admin_id = this.dataCreateForm.admin[0].id;
        this.forms.manager_id = this.dataCreateForm.manager[0].id;
        let start_time_real =
          this.dataCreateForm.timeSheet !== null
            ? this.dataCreateForm.timeSheet.start_time_real
            : "";
        let end_time_real =
          this.dataCreateForm.timeSheet !== null
            ? this.dataCreateForm.timeSheet.end_time_real
            : "";
        this.forms.start_time_real =
          start_time_real !== null ? start_time_real : "";
        this.forms.end_time_real = end_time_real !== null ? end_time_real : "";
        this.forms.start_time_request =
          this.forms.start_time_real <= this.forms.start_time_request &&
          this.forms.start_time_real != ""
            ? this.forms.start_time_real
            : this.forms.start_time_request;
        this.forms.end_time_request =
          this.forms.end_time_real >= this.forms.end_time_request &&
          this.forms.end_time_real != ""
            ? this.forms.end_time_real
            : this.forms.end_time_request;
        // let keyRandom = Math.floor(
        //   Math.random() * this.dataCreateForm.admin.length
        // );
        // this.forms.admin_id = this.dataCreateForm.admin[keyRandom].id;
        this.$root.$loading.finish();
      }
    },

    cancel() {
      this.$confirmModal(
        this.$t("popup.commons.label_popup_title"),
        this.$t("popup.commons.label_cancel_create"),
        this.$t("popup.commons.label_confirm_button"),
        this.$t("popup.commons.label_cancel_button"),
        "danger"
      ).then((value) => {
        if (value) {
          this.$emit("closeModal");
          this.$router.push({ path: "/additional-timesheet" });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form_image {
  padding: 0 0 20px;
}
.img__name {
  display: flex;
}
.image_delete {
  margin-left: 5px;
}
.file__input {
  border: 1px solid #ededed;
  border-radius: 20px;
  background: #f8f8f8;
  height: 35px;
  .file-input__label {
    padding: 6px 14px;
  }
}
.modal_outer_cover {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1030;
  &-content {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    justify-content: center;
  }
}
.create_body_part {
  padding: 25px 378px;
}
.content_create {
  background: #ffffff;
  border-radius: 10px;
}
.create_title {
  padding: 20px 19px;
  border-bottom: 1px solid #3d4cdc;
  background: #d2d6ff;
  border-radius: 10px 10px 0 0;
  display: flex;
  justify-content: space-between;
  span {
    font-size: 16px;
    font-weight: 700;
    color: #3d4cdc;
  }
}
.create_admin {
  padding: 0 0 20px;
  display: flex;
  justify-content: space-between;
  div {
    display: grid;
    width: 45%;
  }
}
.create_bottom {
  padding: 20px 122px;
}
.replenishment_date {
  padding: 0 0 20px;
  display: grid;
  span {
    font-weight: 700;
    color: #303c54;
  }
}
.title {
  font-weight: 700;
  color: #303c54;
}
.star {
  color: #f03d3e;
}
.reason {
  display: grid;
  padding: 0 0 10px;
}
.button_create {
  padding: 20px 0 0;
  margin: auto;
  text-align: center;
  .button_confirm {
    width: 48.5%;
    background: #3d4cdc;
    color: #ffffff;
    border-radius: 10px;
    font-weight: 700;
    height: 40px;
    border: 1px;
  }
  .button_cancel {
    width: 48.5%;
    margin-left: 20px;
    background: #ececec;
    color: #6f6f6f;
    border-radius: 10px;
    font-weight: 700;
    height: 40px;
    border: 1px;
    outline: none;
    box-shadow: none;
  }
}
textarea {
  resize: none;
  border: 1px solid #cfcfcf;
  border-radius: 10px;
}
.morning_time {
  padding: 0 0 20px;
  display: flex;
  justify-content: space-between;
  div {
    display: grid;
    width: 45%;
  }
}
.departure_time {
  padding: 0 0 20px;
  display: flex;
  justify-content: space-between;
  div {
    display: grid;
    width: 45%;
  }
}
.input_date {
  height: 40px;
  border: 1px solid #cfcfcf;
  border-radius: 10px;
  padding: 11px 14px;
}
span.require {
  color: #ff1a1a;
}

span.required {
  color: #ff1a1a;
  margin-top: -15px;
}
</style>